import { render } from "./Politicas.vue?vue&type=template&id=76f57efd&scoped=true"
import script from "./Politicas.vue?vue&type=script&lang=js"
export * from "./Politicas.vue?vue&type=script&lang=js"

import "./Politicas.vue?vue&type=style&index=0&id=76f57efd&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f57efd"]])

export default __exports__